import { useEffect, useRef, useState } from "react";
// import { getProfileApi, updateOwnProfileApi } from "../../app/api";
import {
  cancelPendingProfileDocumentsApi,
  getMyProfileDocumentsApi,
  getMyProfileChangeRequestsApi,
  getUserByIdApi,
  requestProfileChangeApi,
  uploadProfileDocumentsApi,
} from "../../app/api";


import { toast } from "react-toastify";
import {
  Mail,
  Phone,
  Calendar,
  Briefcase,
  User,
  Shield,
  Fingerprint,
  AlertCircle,
  Check,
  ChevronDown,
} from "lucide-react";

import Attendance from "../profile/AttendanceProfile";
import UserLeavesProfile from "../profile/UserLeavesProfile";
import MyLeaves from "../../pages/leaves/MyLeaves";
// import TaskDetailsMy from "../../pages/dashboard/components/TaskDetailsMy";
import UserTaskBoard from "../../pages/dashboard/components/UserTaskBoard";
import { createPortal } from "react-dom";
import UserJourney from "../../components/Tasks/UserJourney";

import { useAuth } from "../../app/store";
import { LogOut } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { convertImageToWebP } from "../../utils/convertImageToWebP";
import { formatDisplayDate, getDateInputValue } from "../../utils/dateFormat";


const IMAGE_BASE = "https://uptask.visiontrek.io";

export default function Profile() {
  // const { logout } = useAuth();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // const [activeTab, setActiveTab] = useState("profile");
  const [activeTab, setActiveTab] = useState("profile");
  const [selectedTaskId, setSelectedTaskId] = useState(null);

  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }

    if (location.state?.taskId) {
      setSelectedTaskId(location.state.taskId);
    }

    if (location.state?.openProfileUpdate) {
      setEditMode(true);
    }
  }, [location.state]);


  const [editMode, setEditMode] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [profileChangeRequest, setProfileChangeRequest] = useState(null);
  const [profileDocuments, setProfileDocuments] = useState([]);
  const [form, setForm] = useState({});
  const [modal, setModal] = useState({
    show: false,
    success: false,
    message: "",
  });
  const [data, setData] = useState(null);

  useEffect(() => {
    if (user?.id) {
      loadProfile();
    }
  }, [user]);



  const loadProfile = async () => {
    if (!user?.id) return;

    const res = await getUserByIdApi();

    if (res.success) {
      const userData = res.data.find(u => u.id === user.id);

      if (!userData) {
        console.error("User not found");
        return;
      }

      setData(userData);

      setForm({
        emp_id: userData.emp_id || "",
        email: userData.email || "",
        first_name: userData.first_name || "",
        last_name: userData.last_name || "",
        phone_number: userData.phone_number || "",
        alter_contact_name: userData.alter_contact_name || "",
        alter_number: userData.alter_number || "",
        department_id: userData.department_id || "",
        job_title: userData.job_title || "",
        dob: getDateInputValue(userData.dob),
        address: userData.address || "",
        current_address: userData.current_address || userData.address || "",
        permanent_address: userData.permanent_address || "",
        father_name: userData.father_name || "",
        mother_name: userData.mother_name || "",
        tenth_year: userData.tenth_year || "",
        twelfth_year: userData.twelfth_year || "",
        graduation_level: userData.graduation_level || "",
        graduation_course: userData.graduation_course || "",
        graduation_year: userData.graduation_year || "",
        post_graduation_level: userData.post_graduation_level || "",
        post_graduation_course: userData.post_graduation_course || "",
        post_graduation_year: userData.post_graduation_year || "",
        // biometric_id: userData.biometric_id || "",
        gender: userData.gender || "",
        joined_at: getDateInputValue(userData.joined_at),
      });

      loadProfileChangeStatus();
      loadProfileDocuments();
    }
  };

  const loadProfileChangeStatus = async () => {
    const res = await getMyProfileChangeRequestsApi();
    if (res.success) {
      const requests = res.data || [];
      setProfileChangeRequest(
        requests.find((request) => request.status === "PENDING") || requests[0] || null
      );
    }
  };

  const loadProfileDocuments = async () => {
    const res = await getMyProfileDocumentsApi();
    if (res.success) {
      setProfileDocuments(res.data || []);
    }
  };

  const handleDocumentUpload = async (files) => {
    const formData = new FormData();

    Object.entries(files).forEach(([field, file]) => {
      if (file) {
        formData.append(field, file);
      }
    });

    if (!Array.from(formData.keys()).length) {
      toast.error("Please choose at least one document");
      return;
    }

    const res = await uploadProfileDocumentsApi(formData);
    if (res.success) {
      toast.success("Documents uploaded for admin approval");
      loadProfileDocuments();
    } else {
      toast.error(res.message || "Unable to upload documents");
    }
  };

  const handleCancelPendingDocuments = async () => {
    const hasPending = profileDocuments.some((doc) => doc.status === "PENDING");
    if (!hasPending) {
      toast.info("No pending uploads to cancel");
      return;
    }

    if (!window.confirm("Cancel all pending document uploads and start fresh?")) {
      return;
    }

    const res = await cancelPendingProfileDocumentsApi();
    if (res.success) {
      toast.success("Pending uploads cancelled");
      loadProfileDocuments();
    } else {
      toast.error(res.message || "Unable to cancel pending uploads");
    }
  };

  const handleProfileFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };


  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("user_id", user.id);
    formData.append("first_name", form.first_name || "");
    formData.append("last_name", form.last_name || "");
    formData.append("email", form.email || "");
    formData.append("phone_number", form.phone_number || "");
    formData.append("address", form.address || "");
    formData.append("current_address", form.current_address || "");
    formData.append("permanent_address", form.permanent_address || "");
    formData.append("father_name", form.father_name || "");
    formData.append("mother_name", form.mother_name || "");
    formData.append("tenth_year", form.tenth_year || "");
    formData.append("twelfth_year", form.twelfth_year || "");
    formData.append("graduation_level", form.graduation_level || "");
    formData.append("graduation_course", form.graduation_course || "");
    formData.append("graduation_year", form.graduation_year || "");
    formData.append("post_graduation_level", form.post_graduation_level || "");
    formData.append("post_graduation_course", form.post_graduation_course || "");
    formData.append("post_graduation_year", form.post_graduation_year || "");

    if (profileImage) {
      const webpImage = await convertImageToWebP(profileImage, {
        maxWidth: 800,
        quality: 0.8,
      });
      formData.append("profile_pic", webpImage);
    }

    const res = await requestProfileChangeApi(formData);

    if (res.success) {
      setModal({
        show: true,
        success: true,
        message: "Profile changes sent for admin review",


      });
      setEditMode(false);
      setProfileImage(null);
      loadProfileChangeStatus();
    } else {
      setModal({
        show: true,
        success: false,
        message: res.message || "Update failed",
      });
    }
  };

  if (!data) {
    return (
      <div className="mt-20 text-white text-center opacity-60">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-6 bg-[#f3f4f8] rounded-3xl">
      {/* ===== HERO ===== */}
      <div className="
        relative rounded-3xl p-6 md:p-8 mb-10
        bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white shadow-2xl md:mt-14
      ">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
          {/* Avatar */}
          <div className="w-24 h-24 rounded-full border-4 border-white/20 overflow-hidden bg-white/10">
            <img
              src={
                data.profile_pic
                  ? `${IMAGE_BASE}${data.profile_pic}`
                  : "/avatar.png"
              }
              className="w-full h-full object-cover"
              alt="profile"
            />
          </div>

          {/* Info */}
          <div className="flex-1">
            <h2 className="text-2xl font-semibold">
              {data.first_name} {data.last_name}
            </h2>
            <p className="text-sm opacity-80">{data.job_title}</p>

            <div className="flex gap-2 mt-2 text-xs">
              <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300">
                Role ID: {data.role_id}
              </span>
              <span
                className={`px-3 py-1 rounded-full text-xs ${data.is_active
                  ? "bg-green-500/20 text-green-300"
                  : "bg-red-500/20 text-red-300"
                  }`}
              >
                {data.is_active ? "Active" : "Inactive"}
              </span>
            </div>
          </div>

          <button
            onClick={() => setEditMode(true)}
            className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm"
          >
            Update Profile
          </button>
        </div>
        {profileChangeRequest?.status === "PENDING" && (
          <div className="mt-5 rounded-2xl border border-amber-300/30 bg-amber-400/10 px-4 py-3 text-sm text-amber-100">
            <span className="font-semibold">Profile changes in admin review.</span>{" "}
            Your new details will go live after approval.
          </div>
        )}
        {profileChangeRequest?.status === "REJECTED" && profileChangeRequest?.admin_reason && (
          <div className="mt-5 rounded-2xl border border-red-300/30 bg-red-400/10 px-4 py-3 text-sm text-red-100">
            Last profile change was rejected: {profileChangeRequest.admin_reason}
          </div>
        )}
      </div>

      <ResponseModal
        show={modal.show}
        success={modal.success}
        message={modal.message}
        onClose={() => setModal({ ...modal, show: false })}
      />

      <EditProfileModal
        show={editMode}
        onClose={() => {
          setEditMode(false);
          setProfileImage(null);
        }}
        form={form}
        handleChange={handleProfileFormChange}
        handleUpdate={handleUpdate}
        profileImage={profileImage}
        setProfileImage={setProfileImage}
        currentImage={data?.profile_pic}
      />

      <div className="flex gap-2 md:gap-4 mb-6 overflow-x-auto no-scrollbar p-2 ">
        {["profile", "attendance", "leave", "task", "journey"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`
              px-6 py-2 text-sm font-semibold uppercase tracking-wide
              rounded-full transition-all duration-300
              ${activeTab === tab
                ? "bg-gradient-to-r from-purple-500 to-purple-700 text-white shadow-lg scale-105"
                : "bg-[#dbc4f2] text-[#5f1ea0] hover:bg-purple-200 shadow-lg"
              }
            `}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ===== CONTENT ===== */}
      {activeTab === "profile" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <GlassCard title="Basic Information">
            <Stat label="Email" value={data.email} />
            <Stat label="Phone" value={data.phone_number || "Not provided"} />
            <Stat label="Gender" value={data.gender || "—"} />
            <Stat label="Job Title" value={data.job_title} />
            <Stat label="Father Name" value={data.father_name || "Not provided"} />
            <Stat label="Mother Name" value={data.mother_name || "Not provided"} />
          </GlassCard>

          <GlassCard title="Emergency Contact">
            <Stat label="Alternate Contact Name" value={data.alter_contact_name || "Not set"} />
            <Stat label="Alternate Contact Number" value={data.alter_number || "Not set"} />
            <Stat label="Current Address" value={data.current_address || data.address || "Not provided"} />
            <Stat label="Permanent Address" value={data.permanent_address || "Not provided"} />
          </GlassCard>

          <GlassCard title="Account">
            <Stat label="Employee ID" value={data.emp_id} />
            <Stat label="Role ID" value={data.role_id} />
            <Stat label="Joined" value={formatDisplayDate(data.joined_at)} />
            <Stat label="Date of Birth" value={formatDisplayDate(data.dob, "Not provided")} />
            <Stat label="10th Completed" value={data.tenth_year || "Not provided"} />
            <Stat label="12th Completed" value={data.twelfth_year || "Not provided"} />
            <Stat label="Graduation" value={[data.graduation_level, data.graduation_course, data.graduation_year].filter(Boolean).join(" • ") || "Not provided"} />
            <Stat label="Post Graduation" value={[data.post_graduation_level, data.post_graduation_course, data.post_graduation_year].filter(Boolean).join(" • ") || "Not provided"} />
          </GlassCard>

          <div className="md:col-span-3">
            <ProfileDocumentsPanel
              documents={profileDocuments}
              onUpload={handleDocumentUpload}
              onCancelPending={handleCancelPendingDocuments}
            />
          </div>
        </div>
      )}

      {activeTab === "attendance" && (
        <div className="
          rounded-2xl p-5 mt-4
          bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
          shadow-2xl
        ">
          <Attendance />
        </div>
      )}

      {activeTab === "leave" && (
        <div className="mt-[-44px]">
          <MyLeaves />
        </div>
      )}

      {activeTab === "task" && (
        <div className="mt-[-14px]">
          <UserTaskBoard userId={user.id} />
        </div>
      )}

      {activeTab === "journey" && (
        <div className="mt-4 p-6 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] rounded-3xl border border-white/10 shadow-2xl">
          <UserJourney userId={user.id} />
        </div>
      )}
    </div>
  );
}

/* ===== UI HELPERS ===== */

function GlassCard({ title, children }) {
  return (
    <div className="
      rounded-2xl p-5
      bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
      text-white backdrop-blur-xl
      border border-white/20
      shadow-xl
    ">
      <h3 className="font-semibold mb-4">{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <p className="text-xs opacity-60">{label}</p>
      <p className="font-medium">{value || "—"}</p>
    </div>
  );
}

const DOCUMENT_LABELS = {
  aadhaar_front: "Aadhaar Front",
  aadhaar_back: "Aadhaar Back",
  pan: "PAN Card",
  license: "Driving License",
  resume: "Resume",
};

function ProfileDocumentsPanel({ documents, onUpload, onCancelPending }) {
  const [files, setFiles] = useState({});
  const approvedDocs = documents.filter((doc) => doc.status === "APPROVED");
  const pendingDocs = documents.filter((doc) => doc.status === "PENDING");
  const rejectedDocs = documents.filter((doc) => doc.status === "REJECTED");

  const setFile = (field, file) => {
    setFiles((prev) => ({ ...prev, [field]: file }));
  };

  const submit = async (event) => {
    event.preventDefault();
    const formElement = event.currentTarget;
    await onUpload(files);
    setFiles({});
    formElement?.reset();
  };

  return (
    <div className="rounded-2xl border border-white/20 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] p-5 text-white shadow-xl">
      <div className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-cyan-200/80">
            Verification documents
          </p>
          <h3 className="mt-1 text-xl font-semibold">Citizen Documents & Resume</h3>
          <p className="mt-1 text-sm text-white/60">
            Upload clear Aadhaar, PAN, license or resume files. Images are saved as WEBP and require admin approval.
          </p>
        </div>
        {pendingDocs.length > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-amber-400/15 px-3 py-1 text-xs font-semibold text-amber-200">
              {pendingDocs.length} pending review
            </span>
            <button
              type="button"
              onClick={onCancelPending}
              className="rounded-full border border-red-300/25 bg-red-400/10 px-3 py-1 text-xs font-semibold text-red-100 hover:bg-red-400/20"
            >
              Cancel pending uploads
            </button>
          </div>
        )}
      </div>

      <form onSubmit={submit} className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-5">
        <DocumentInput
          label="Aadhaar Front"
          hint="Upload clear Aadhaar card front photo"
          accept="image/*"
          onChange={(file) => setFile("aadhaar_front", file)}
        />
        <DocumentInput
          label="Aadhaar Back"
          hint="Optional, upload if back side is required"
          accept="image/*"
          optional
          onChange={(file) => setFile("aadhaar_back", file)}
        />
        <DocumentInput
          label="PAN Card"
          hint="Upload clear PAN image"
          accept="image/*"
          onChange={(file) => setFile("pan", file)}
        />
        <DocumentInput
          label="License"
          hint="Optional"
          accept="image/*"
          optional
          onChange={(file) => setFile("license", file)}
        />
        <DocumentInput
          label="Resume"
          hint="Optional PDF, DOC or DOCX"
          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          optional
          onChange={(file) => setFile("resume", file)}
        />

        <div className="md:col-span-2 xl:col-span-5 flex justify-end">
          <button className="rounded-xl bg-gradient-to-r from-cyan-400 to-blue-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-cyan-500/20">
            Upload for Approval
          </button>
        </div>
      </form>

      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        <DocumentList title="Approved Documents" docs={approvedDocs} empty="No approved documents yet" />
        <DocumentList
          title="Pending Approval"
          docs={pendingDocs}
          empty="No pending documents"
          onCancelAll={pendingDocs.length ? onCancelPending : null}
        />
        <DocumentList title="Rejected" docs={rejectedDocs} empty="No rejected documents" showReason />
      </div>
    </div>
  );
}

function DocumentInput({ label, hint, accept, optional = false, onChange }) {
  return (
    <label className="rounded-2xl border border-white/15 bg-white/[0.06] p-4">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold">{label}</span>
        {optional && <span className="text-[10px] uppercase tracking-wider text-white/40">Optional</span>}
      </div>
      <p className="mt-1 min-h-[34px] text-xs text-white/50">{hint}</p>
      <input
        type="file"
        accept={accept}
        onChange={(event) => onChange(event.target.files?.[0] || null)}
        className="mt-3 w-full text-xs text-white/65 file:mr-3 file:rounded-lg file:border-0 file:bg-cyan-400 file:px-3 file:py-2 file:text-xs file:font-semibold file:text-[#0b1028]"
      />
    </label>
  );
}

function isImageDocument(doc) {
  return String(doc.mime_type || "").startsWith("image/");
}

function DocumentList({ title, docs, empty, showReason = false, onCancelAll = null }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-black/15 p-4">
      <div className="flex items-center justify-between gap-3">
        <h4 className="font-semibold">{title}</h4>
        {onCancelAll && (
          <button
            type="button"
            onClick={onCancelAll}
            className="shrink-0 rounded-full border border-red-300/25 bg-red-400/10 px-3 py-1 text-xs font-semibold text-red-100 hover:bg-red-400/20"
          >
            Cancel all
          </button>
        )}
      </div>
      <div className="mt-3 space-y-2">
        {docs.length === 0 ? (
          <p className="text-sm text-white/45">{empty}</p>
        ) : (
          docs.map((doc) => (
            <a
              key={doc.id}
              href={`${IMAGE_BASE}${doc.file_path}`}
              target="_blank"
              rel="noreferrer"
              className="block rounded-xl border border-white/10 bg-white/[0.06] p-3 hover:bg-white/10"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold">{doc.document_label || DOCUMENT_LABELS[doc.document_type]}</span>
                <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px]">{doc.status}</span>
              </div>
              <p className="mt-1 truncate text-xs text-white/50">{doc.original_name || doc.file_path}</p>
              {isImageDocument(doc) && (
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-cyan-200/70">
                  Saved as WEBP
                </p>
              )}
              {showReason && doc.admin_reason && (
                <p className="mt-2 text-xs text-red-200">Reason: {doc.admin_reason}</p>
              )}
            </a>
          ))
        )}
      </div>
    </div>
  );
}

/* ================= RESPONSE MODAL ================= */
function ResponseModal({ show, success, message, onClose }) {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl w-[320px] text-center">
        <h2 className={`text-xl font-bold mb-3 ${success ? "text-green-600" : "text-red-600"}`}>
          {success ? "Success" : "Failed"}
        </h2>

        <p className="text-gray-600 mb-4">{message}</p>

        <button
          onClick={onClose}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
        >
          OK
        </button>
      </div>
    </div>,
    document.body
  );
}

/* ================= EDIT PROFILE MODAL ================= */
function EditProfileModal({
  show,
  onClose,
  form,
  handleChange,
  handleUpdate,
  profileImage,
  setProfileImage,
  currentImage,
}) {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Glass Card */}
      <div
        className="
        relative w-full max-w-3xl max-h-[90vh] overflow-y-auto
        rounded-2xl p-8
        bg-white/10 backdrop-blur-xl
        border border-white/20
        shadow-2xl
        text-white
      "
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-cyan-200/80">
              Admin review
            </p>
            <h2 className="text-2xl font-semibold">Request Profile Update</h2>
            <p className="mt-1 text-sm text-white/60">
              Photo, name, email, phone and address changes will be reviewed before they go live.
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white text-xl"
          >
            ✕
          </button>
        </div>

        <div className="mb-6 rounded-2xl border border-white/15 bg-white/[0.06] p-4">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-4">
              <div className="h-20 w-20 overflow-hidden rounded-2xl border border-white/20 bg-white/10">
                {profileImage ? (
                  <img
                    src={URL.createObjectURL(profileImage)}
                    className="h-full w-full object-cover"
                    alt="Selected profile preview"
                  />
                ) : currentImage ? (
                  <img
                    src={`${IMAGE_BASE}${currentImage}`}
                    className="h-full w-full object-cover"
                    alt="Current profile"
                  />
                ) : (
                  <div className="grid h-full w-full place-items-center text-sm text-white/50">
                    Photo
                  </div>
                )}
              </div>
              <div>
                <p className="font-semibold">Profile Photo</p>
                <p className="text-sm text-white/55">
                  Upload a new picture. It will be visible after admin approval.
                </p>
              </div>
            </div>

            <label className="inline-flex cursor-pointer items-center justify-center rounded-xl bg-cyan-400 px-4 py-3 text-sm font-semibold text-[#0b1028] shadow-lg shadow-cyan-400/20">
              Choose Photo
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(event) => setProfileImage(event.target.files?.[0] || null)}
              />
            </label>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleUpdate} className="grid md:grid-cols-2 gap-4">
          <FormSection title="Personal Details">
            <GlassInput label="First Name" name="first_name" value={form.first_name} onChange={handleChange} />
            <GlassInput label="Last Name" name="last_name" value={form.last_name} onChange={handleChange} />
            <GlassInput label="Email" name="email" value={form.email} onChange={handleChange} />
            <GlassInput label="Phone Number" name="phone_number" value={form.phone_number} onChange={handleChange} />
            <GlassInput label="Father Name" name="father_name" value={form.father_name} onChange={handleChange} />
            <GlassInput label="Mother Name" name="mother_name" value={form.mother_name} onChange={handleChange} />
          </FormSection>

          <FormSection title="Address Details">
            <GlassTextarea
              label="Current Address"
              name="current_address"
              value={form.current_address}
              onChange={(event) => {
                handleChange(event);
                handleChange({ target: { name: "address", value: event.target.value } });
              }}
            />
            <GlassTextarea
              label="Permanent Address / Home Town"
              name="permanent_address"
              value={form.permanent_address}
              onChange={handleChange}
            />
          </FormSection>

          <FormSection title="Education Details">
            <YearSelect label="10th Finished Year" name="tenth_year" value={form.tenth_year} onChange={handleChange} />
            <YearSelect label="12th Finished Year" name="twelfth_year" value={form.twelfth_year} onChange={handleChange} />
            <GlassSelect label="Graduation" name="graduation_level" value={form.graduation_level} onChange={handleChange} options={graduationOptions} />
            <GlassInput label="Graduation Course" name="graduation_course" value={form.graduation_course} onChange={handleChange} placeholder="e.g. B.Tech CSE" />
            <YearSelect label="Graduation Year" name="graduation_year" value={form.graduation_year} onChange={handleChange} />
            <GlassSelect label="Post Graduation" name="post_graduation_level" value={form.post_graduation_level} onChange={handleChange} options={postGraduationOptions} />
            <GlassInput label="Post Graduation Course" name="post_graduation_course" value={form.post_graduation_course} onChange={handleChange} placeholder="e.g. MBA / MCA" />
            <YearSelect label="Post Graduation Year" name="post_graduation_year" value={form.post_graduation_year} onChange={handleChange} />
          </FormSection>

          {/* Footer Buttons */}
          <div className="md:col-span-2 flex justify-end gap-4 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-white/20 hover:bg-white/30 transition"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-6 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 transition"
            >
              Send for Review
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

const graduationOptions = [
  "B.A",
  "B.Com",
  "B.Sc",
  "B.Tech",
  "B.E",
  "BCA",
  "BBA",
  "B.Des",
  "Diploma",
  "Other",
];

const postGraduationOptions = [
  "M.A",
  "M.Com",
  "M.Sc",
  "M.Tech",
  "M.E",
  "MCA",
  "MBA",
  "PG Diploma",
  "Other",
  "Not Applicable",
];

const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 26 }, (_, index) => String(currentYear - index));
};

function FormSection({ title, children }) {
  return (
    <section className="md:col-span-2 rounded-2xl border border-white/15 bg-white/[0.05] p-4">
      <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-cyan-100/80">
        {title}
      </h3>
      <div className="grid gap-4 md:grid-cols-2">{children}</div>
    </section>
  );
}

function GlassInput({ label, ...props }) {
  return (
    <div>
      <label className="text-xs text-white/70 mb-1 block">{label}</label>
      <input
        {...props}
        className="
          w-full
          bg-white/10
          border border-white/20
          rounded-lg
          p-3
          backdrop-blur-md
          focus:outline-none
        "
      />
    </div>
  );
}

function GlassDropdown({ label, name, value, onChange, options = [], placeholder = "Select" }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const normalizedValue = value ? String(value) : "";
  const showSavedValue = normalizedValue && !options.map(String).includes(normalizedValue);
  const displayOptions = showSavedValue ? [normalizedValue, ...options.map(String)] : options.map(String);

  useEffect(() => {
    if (!open) return;

    const closeOnOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, [open]);

  const selectOption = (nextValue) => {
    onChange?.({ target: { name, value: nextValue } });
    setOpen(false);
  };

  return (
    <div ref={dropdownRef} className="relative">
      <label className="text-xs text-white/70 mb-1 block">{label}</label>
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        className="
          w-full
          min-h-[50px]
          bg-white/[0.11]
          border border-white/20
          rounded-xl
          px-4 py-3
          text-left text-white
          backdrop-blur-xl
          shadow-[inset_0_1px_0_rgba(255,255,255,0.10),0_12px_30px_rgba(6,3,20,0.12)]
          transition
          hover:border-cyan-100/45 hover:bg-white/[0.14]
          focus:outline-none focus:border-cyan-200/80 focus:ring-2 focus:ring-cyan-200/25
          flex items-center justify-between gap-3
        "
      >
        <span className={normalizedValue ? "font-semibold text-white" : "font-semibold text-white/45"}>
          {normalizedValue || placeholder}
        </span>
        <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg border border-white/10 bg-white/10 text-cyan-100 transition ${open ? "rotate-180" : ""}`}>
          <ChevronDown size={17} />
        </span>
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-[calc(100%+8px)] z-[10050] overflow-hidden rounded-2xl border border-cyan-100/20 bg-[#171126]/95 p-1.5 text-white shadow-[0_28px_80px_rgba(3,1,12,0.65)] backdrop-blur-2xl">
          <button
            type="button"
            onClick={() => selectOption("")}
            className={`flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-left text-sm font-semibold transition ${
              !normalizedValue ? "bg-cyan-300/16 text-cyan-100" : "text-white/70 hover:bg-white/10 hover:text-white"
            }`}
          >
            <span className="grid h-5 w-5 place-items-center">
              {!normalizedValue && <Check size={16} strokeWidth={3} />}
            </span>
            {placeholder}
          </button>

          <div className="max-h-64 overflow-y-auto pr-1 [scrollbar-width:thin] [scrollbar-color:rgba(125,211,252,0.45)_transparent]">
            {displayOptions.map((option) => {
              const selected = normalizedValue === option;

              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => selectOption(option)}
                  className={`mt-1 flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-left text-sm font-semibold transition ${
                    selected
                      ? "bg-gradient-to-r from-cyan-400/25 to-violet-400/18 text-white ring-1 ring-cyan-200/20"
                      : "text-white/75 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  <span className="grid h-5 w-5 place-items-center text-cyan-100">
                    {selected && <Check size={16} strokeWidth={3} />}
                  </span>
                  <span>{option}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

function GlassSelect(props) {
  return <GlassDropdown {...props} placeholder="Select" />;
}

function YearSelect(props) {
  return <GlassDropdown {...props} options={getYearOptions()} placeholder="Select year" />;
}

function GlassTextarea({ label, ...props }) {
  return (
    <div className="md:col-span-1">
      <label className="text-xs text-white/70 mb-1 block">{label}</label>
      <textarea
        {...props}
        rows={3}
        className="
          w-full
          bg-white/10
          border border-white/20
          rounded-lg
          p-3
          backdrop-blur-md
          focus:outline-none
        "
      />
    </div>
  );
}
